const getters = {
  alert: (state) => state.alert,
  appLoading: state => state.appLoading,
};

export default getters;
